module.exports = __webpack_public_path__ + "static/media/btcb-eth.3b4285d9.svg";